import { itdrApi } from "./api";

const tenantService = {

  async getTenantInfo() {
    const response = await itdrApi.get('/tenant/info');
    // console.log("getinfo",response.data)
    return response;
  },

  async updateTenantInfo(data) {
    const response = await itdrApi.post('/tenant/info',data);
    // console.log()
    return response;
  },
  
};

export default tenantService;